import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { IonicStorageModule } from "@ionic/storage";
import { IonicApp, IonicModule } from "ionic-angular";
import { Ng2ImgToolsModule } from "ng2-img-tools";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { Api } from "../providers/api/api";
import { AccountService } from "../providers/auth/account.service";
import { AuthInterceptor } from "../providers/auth/auth-interceptor";
import { AuthServerProvider } from "../providers/auth/auth-jwt.service";
import { Principal } from "../providers/auth/principal.service";
import { AppErrorHandler } from "../providers/error/app-error-handler";
import { LoginService } from "../providers/login/login.service";
import { ManagementService } from "../providers/management/management.provider";
import { ProgrammeService } from "../providers/programme/programme.provider";
import { MyApp } from "./app.component";
import { FacebookModule } from "ngx-facebook";

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    Ng2ImgToolsModule,
    FacebookModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    SplashScreen,
    StatusBar,
    // Error handling
    { provide: ErrorHandler, useClass: AppErrorHandler },
    // Adding Header Authorization: Bearer
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    LocalStorageService,
    SessionStorageService,
    // Common providers to all modules
    Api,
    LoginService,
    Principal,
    AccountService,
    AuthServerProvider,
    ManagementService,
    ProgrammeService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts